import toast from "react-hot-toast";
import axios from "axios";
import { serverURL } from './auth';

const addBasket = (addedProduct) => {
    try {
        const basket = JSON.parse(localStorage.getItem('basket')) || [];

        const existProduct = basket.find(product => product.productOptionId === addedProduct.productOptionId);

        if (existProduct) {
            existProduct.quantity = addedProduct.quantity;
        } else {
            basket.push(addedProduct);
        }

        localStorage.setItem('basket', JSON.stringify(basket));

        toast.success('Termék sikeresen hozzáadva a kosárhoz!');

    } catch (error) {
        toast.error("Hiba történt a termék hozzáadásánál");
    };
};

const editBasket = (basket) => {
    try {
        localStorage.setItem('basket', JSON.stringify(basket));
    } catch (error) {
        console.error("Hiba történt a kosár módosításánál: ", error);
    };
};

const getBasket = () => {
    try {
        const basket = JSON.parse(localStorage.getItem('basket')) || [];
        return basket;
    } catch (error) {
        console.error("Hiba történt a kosár lekérésével: ", error);
        return [];
    }
};

const sendOrder = async (orderDetails) => {
    try {
        const res = await axios.post(`${serverURL}/api/orders/addneworder`, { orderDetails }, { withCredentials: true });

        if (res.status === 200) {
            localStorage.removeItem('basket');
            return res.data.url;
        }
    } catch (err) {
        console.error(err);
        return `https://kreativoromok.hu/errorpay`;
    };
};


const getOrders = async () => {
    try {
        const res = await axios.get(`${serverURL}/api/orders/getorders`, { withCredentials: true });

        if (res.status === 200) {
            return res.data.results;
        }
    } catch (err) {
        console.error('Error occurred:', err.message);
        return [];
    }
};

const changeStatus = async (order) => {
    try {
      const res = await axios.put(`${serverURL}/api/orders/changeorderstatus`, { order }, { withCredentials: true });
  
      if (res.status === 200) {
        toast.success("Rendelés állapota sikeresen módosítva!")
        return true;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error('Bejelentkezési probléma!');
        return false;
      } else {
  
        console.error(err);
        toast.error('Szerver hiba');
        return false;
      }
    }
};

const getFoxpost = async () => {
    try {
        const res = await axios.get(`https://cdn.foxpost.hu/foxplus.json`);

        if (res.status === 200) {
            return res.data;
        }
    } catch (err) {
        console.error('Error occurred:', err.message);
        return [];
    }
};


export {
    addBasket,
    getBasket,
    editBasket,
    sendOrder,
    getOrders,
    changeStatus,
    getFoxpost
}